import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAutoResize]'  // Apply this directive to the input field
})
export class AutoResizeDirective {

  constructor(private el: ElementRef) { 
    console.log("weifht", this.el.nativeElement.scrollWidth);
  }

  // Listen for the input event
  @HostListener('input') onInput() {
    this.resize();
  }

ngAfterViewInit() {
    this.logWidth();
  }

    // Log the width of the element after the view has been initialized
  private logWidth() {
    const textarea: HTMLTextAreaElement = this.el.nativeElement;

    // Log the clientWidth and offsetWidth after rendering
    console.log('Client Width (visible width including padding):', textarea.clientWidth);  
    console.log('Offset Width (layout width including padding and borders):', textarea.offsetWidth); 
  }

  private resize(): void {
    const input: HTMLTextAreaElement = this.el.nativeElement;

    // Reset width to 'auto' to recalculate based on content
    input.style.width = 'auto';

    // Get the current width of the content
    const contentWidth = input.scrollWidth;
    console.log("content", contentWidth);

    // Subtract padding (and borders if necessary) to get an accurate width measurement
    const padding = parseFloat(getComputedStyle(input).paddingLeft) + parseFloat(getComputedStyle(input).paddingRight);
    const borderWidth = parseFloat(getComputedStyle(input).borderLeftWidth) + parseFloat(getComputedStyle(input).borderRightWidth);

    // Correct the content width by considering padding/border
    const adjustedWidth = contentWidth - padding - borderWidth;
    console.log("adjuste", adjustedWidth);

    // Expand width based on content, but stop at max-width of 250px
    if (adjustedWidth <= 250) {
      input.style.width = `${contentWidth}px`;
    } else {
      input.style.width = '250px';  // Stop expanding once it reaches 250px
    }

    // Adjust the height (this will automatically handle vertical expansion)
    input.style.height = `${input.scrollHeight}px`;
  }
}